export default "https://a.travel-assets.com/partner-portal/angle_edge_green.32533f7d9537.svg";